import { getCookie, setCookie, deleteCookie } from '../utils/dom';
import { deepClone } from '../utils/object';
import { shippingMethodsMapping } from '../config';
import {
	VOUCHER_INPUT,
	VOUCHER_ERROR,
	PRE_SELECT_SIZE,
	LIST_ITEM_CACHE,
	SELECT_SIZE,
	ADD_TO_BAG_ERROR,
	UPDATE_SELECTION_CACHE,
	UPDATE_SELECTION,
	GET_ADDRESS,
	UPDATE_ADDRESS,
	UPDATE_ERRORS,
	DELIVERY_PROCEED,
	KLARNA_LOADED,
	KLARNA_UNLOADED,
	ADYEN_INITIATED,
	STRIPE_INITIATED,
	STRIPE_PAYMENT_INTENTS_INITIATED,
	PAYMENT_UPDATING,
	SELECTION_ERROR,
	SELECTION_ERROR_STOCK,
	UPDATE_BUDBEE,
	INITIATED_SCRIPT,
	PAYMENT_RETURN,
	BOOLEAN_CHANGE,
	DESTROY_SELECTION,
	ERROR_NOTIFICATION,
	SUCCESS_NOTIFICATION,
} from '../actions/checkout';

let token = null;
if (!token && typeof localStorage !== 'undefined') {
	// transition to cookie based selection.
	token = localStorage.getItem('selection');
	if (token) {
		localStorage.removeItem('selection');
		setCookie('selection', token, 365);
	}
}
if (!token && typeof document !== 'undefined') token = getCookie('selection');

const initialState = {
	items: {},
	preSelectedSize: '',
	selectionCache: {},
	useShippingAddress: false,
	initiatedScript: false,
	vouchers: {
		currentValue: '',
		error: false,
	},
	addressRetrieved: {
		successful: false,
		error: false,
	},
	payment: {
		address: {},
		shippingAddress: {},
		paymentFailedPage: '',
		paymentReturnPage: '',
		termsAndConditions: true,
	},
	shippingAvailable: {},
	deliveryProceed: false,
	klarnaLoaded: false,
	klarnaUnloaded: false,
	paymentReturn: {},
	addToBagError: false,
	selectionError: false,
	selectionErrorStock: false,
	selection: {},
	destroySelection: false,
	notification_sent: false,
	notification_error: false,
};

if (token) initialState.selection.token = token;
if (shippingMethodsMapping.budbee) initialState.shippingAvailable[shippingMethodsMapping.budbee] = false;

const checkout = (state = initialState, action = {}) => {
	switch (action.type) {
		case PRE_SELECT_SIZE: {
			return {
				...state,
				preSelectedSize: action.item,
			};
		}

		case SELECT_SIZE: {
			return {
				...state,
				selectionError: false,
				selectionErrorStock: false,
				addToBagError: false,
				items: {
					...state.items,
					[action.product]: {
						...state.items[action.product],
						size: action.item,
						quantity: action.quantity,
					},
				},
			};
		}

		case LIST_ITEM_CACHE: {
			let listItemCache = typeof localStorage !== 'undefined' ? JSON.parse(localStorage.getItem('listItemCache')) : {};
			listItemCache = listItemCache || {};

			if (action.productId && action.listName) listItemCache[action.productId] = action.listName;

			if (typeof localStorage !== 'undefined' && Object.keys(listItemCache).length > 0) localStorage.setItem('listItemCache', JSON.stringify(listItemCache));
			return {
				...state,
				listItemCache,
			};
		}

		case ADD_TO_BAG_ERROR: {
			return {
				...state,
				addToBagError: true,
			};
		}

		case 'INIT_SELECTION_CACHE': {
			return {
				...state,
				selectionCache: action.initCache,
			};
		}

		case UPDATE_SELECTION_CACHE: {
			let updatedCache;

			if (!action.productCache && state.selectionCache[action.product]) {
				// Remove from cache
				updatedCache = Object.keys(state.selectionCache).reduce((acc, obj) => (obj !== action.product ? { ...acc, [obj]: state.selectionCache[obj] } : { ...acc }), {});
			} else if (Array.isArray(action.product)) {
				// Update all in selectionCache
				updatedCache = Object.keys(action.productCache).reduce((acc, product) => {
					const currentProductCache = action.selectionCache[product].generatedClientSide ? action.selectionCache[product] : action.productCache[product];
					return (currentProductCache ? { ...acc, [product]: { ...currentProductCache, category: (action.selectionCache[product].category ? action.selectionCache[product].category : action.productCache[product].canonicalUri) } } : acc);
				}, {});
			} else {
				// Add to cache
				updatedCache = {
					...state.selectionCache,
					[action.product]: action.productCache,
				};
			}

			localStorage.setItem('selectionCache', JSON.stringify(updatedCache));

			return {
				...state,
				selectionCache: updatedCache,
			};
		}

		case 'INITIATE_SELECTION': {
			return {
				...state,
				paymentReturn: {
					...state.paymentReturn,
					paymentHTML: action.formHtml,
				},
			};
		}

		case UPDATE_SELECTION: {
			// localStorage.setItem('selection', action.data.token);
			// Move to using cookie based selection.
			setCookie('selection', action.data.token, 365);

			// Why does it update if there is no selection ?
			if (!action.data.selection) return { ...state };

			return {
				...state,
				selectionError: false,
				selectionErrorStock: false,
				addToBagError: false,
				selection: { // Replace all data every time.
					token: action.data.token,
					paymentMethod: action.data.selection.paymentMethod,
					shippingMethod: action.data.selection.shippingMethod,
					items: action.data.selection.items.map((item) => ({
						item: item.item,
						size: item.size,
						name: item.product.name,
						id: `p${item.product.centraProduct}-v${item.product.centraVariant}`, // Match google merchant feed.
						sku: item.product.productSku,
						brand: item.product.brandName,
						variant: item.product.variantName,
						category: item.product.categoryUri,
						quantity: item.quantity,
						line: item.line,
						priceEach: item.priceEach,
						priceEachAsNumber: item.priceEachAsNumber,
						totalPrice: item.totalPrice,
						totalPriceAsNumber: item.totalPriceAsNumber,
						priceEachBeforeDiscount: item.priceEachBeforeDiscount,
						priceEachBeforeDiscountAsNumber: item.priceEachBeforeDiscountAsNumber,
						anyDiscount: item.anyDiscount,
						taxPercent: item.taxPercent,
						priceEachWithoutTax: item.priceEachWithoutTax,
						priceEachWithoutTaxAsNumber: item.priceEachWithoutTaxAsNumber,
						priceEachReduction: item.priceEachReduction,
						priceEachReductionAsNumber: item.priceEachReductionAsNumber,
					})),
					discounts: deepClone(action.data.selection.discounts),
					totals: { ...action.data.selection.totals },
					paymentMethods: action.data.paymentMethods.map((method) => ({ ...method })),
					shippingMethods: action.data.shippingMethods.map((method) => ({ ...method })),
					paymentFields: deepClone(action.data.paymentFields),
				},
			};
		}

		case 'INIT_PAYMENT_INFO': {
			return {
				...state,
				payment: action.paymentInfo,
			};
		}

		case DELIVERY_PROCEED: {
			return {
				...state,
				deliveryProceed: true,
			};
		}

		case KLARNA_UNLOADED: {
			return {
				...state,
				klarnaUnloaded: true,
			};
		}

		case KLARNA_LOADED: {
			return {
				...state,
				klarnaLoaded: true,
			};
		}

		case ADYEN_INITIATED: {
			return {
				...state,
				adyenInitiated: true,
			};
		}

		case STRIPE_INITIATED: {
			return {
				...state,
				stripeInitiated: true,
			};
		}

		case STRIPE_PAYMENT_INTENTS_INITIATED: {
			return {
				...state,
				stripePaymentIntentsInitiated: true,
			};
		}

		case PAYMENT_UPDATING: {
			return {
				...state,
				paymentUpdating: action.isUpdating,
			};
		}

		case UPDATE_ADDRESS: {
			const paymentInfo = action.group ? {
				...state.payment,
				[action.group]: {
					...state.payment[action.group],
					[action.id]: action.value,
				},
			} : {
				...state.payment,
				[action.id]: action.value,
			};

			if (typeof localStorage !== 'undefined') localStorage.setItem('paymentInfo', JSON.stringify(paymentInfo));

			return {
				...state,
				deliveryProceed: !((action.id === 'zipCode' && state.deliveryProceed && state.payment[action.group][action.id] !== action.value) || !state.deliveryProceed),
				selectionError: false,
				selectionErrorStock: false,
				payment: paymentInfo,
				notification_sent: false,
				notification_error: false,
			};
		}

		case UPDATE_ERRORS: {
			if (action.group) {
				const field = state.selection.paymentFields[action.group][action.id];
				if (action.id === 'state') field.required = true;

				return {
					...state,
					selection: {
						...state.selection,
						paymentFields: {
							...state.selection.paymentFields,
							[action.group]: {
								...state.selection.paymentFields[action.group],
								[action.id]: {
									...state.selection.paymentFields[action.group][action.id],
									error: field.visible && field.required ? action.error : false,
								},
							},
						},
					},
				};
			}
			if (state.selection.paymentFields[action.id]) {
				const singleField = state.selection.paymentFields[action.id];
				return {
					...state,
					selection: {
						...state.selection,
						paymentFields: {
							...state.selection.paymentFields,
							[action.id]: {
								...state.selection.paymentFields[action.id],
								error: singleField.visible && singleField.required ? action.error : false,
							},
						},
					},
				};
			}
			return { ...state };
		}

		case SELECTION_ERROR: {
			return {
				...state,
				selectionError: action.hasError,
			};
		}

		case SELECTION_ERROR_STOCK: {
			return {
				...state,
				selectionErrorStock: action.hasError,
			};
		}

		case GET_ADDRESS: {
			if (!action.success) {
				return {
					...state,
					addressRetrieved: {
						...state.addressRetrieved,
						error: true,
					},
				};
			}
			return {
				...state,
				addressRetrieved: {
					...state.addressRetrieved,
					successful: true,
					error: false,
				},
				payment: {
					...state.payment,
					address: {
						...state.payment.address,
						...action.data.address,
					},
				},
			};
		}

		case UPDATE_BUDBEE: {
			return {
				...state,
				shippingAvailable: {
					...state.shippingAvailable,
					[shippingMethodsMapping.budbee]: action.success,
				},
			};
		}

		case BOOLEAN_CHANGE: {
			if (action.id === 'useShipping') {
				return {
					...state,
					selectionError: false,
					selectionErrorStock: false,
					useShippingAddress: !state.useShippingAddress,
					payment: {
						...state.payment,
						shippingAddress: {
							...state.payment.shippingAddress,
							email: state.payment.shippingAddress.email || state.payment.address.email,
							firstName: state.payment.shippingAddress.firstName || state.payment.address.firstName,
							lastName: state.payment.shippingAddress.lastName || state.payment.address.lastName,
							company: state.payment.shippingAddress.company || state.payment.address.company,
							phoneNumber: state.payment.shippingAddress.phoneNumber || state.payment.address.phoneNumber,
							address1: state.payment.shippingAddress.address1 || state.payment.address.address1,
							address2: state.payment.shippingAddress.address2 || state.payment.address.address2,
							zipCode: state.payment.shippingAddress.zipCode || state.payment.address.zipCode,
							city: state.payment.shippingAddress.city || state.payment.address.city,
							state: state.payment.shippingAddress.state || state.payment.address.state,
							country: state.payment.shippingAddress.country || state.payment.address.country,
						},
					},
				};
			}
			if (action.id === 'subscribeToNewsletter') {
				return {
					...state,
					selectionError: false,
					selectionErrorStock: false,
					payment: {
						...state.payment,
						address: {
							...state.payment.address,
							newsletter: !state.payment.address.newsletter,
						},
					},
				};
			}

			const paymentInfo = {
				...state.payment,
				[action.id]: !state.payment[action.id],
			};

			localStorage.setItem('paymentInfo', JSON.stringify(paymentInfo));

			return {
				...state,
				selectionError: false,
				selectionErrorStock: false,
				payment: paymentInfo,
			};
		}

		case VOUCHER_INPUT: {
			return {
				...state,
				selectionError: false,
				selectionErrorStock: false,
				vouchers: {
					...state.vouchers,
					currentValue: action.value,
					error: false,
				},
			};
		}

		case VOUCHER_ERROR: {
			return {
				...state,
				vouchers: {
					...state.vouchers,
					error: !state.vouchers.error,
				},
			};
		}

		case PAYMENT_RETURN: {
			if (window.CentraCheckout) window.CentraCheckout.resume();
			if (!action.data) {
				return {
					...state,
					paymentReturn: {},
				};
			}
			return {
				...state,
				paymentReturn: {
					paymentHTML: action.data.selection?.pluginFields?.paymentHTML || state.paymentReturn.paymentHTML || '',
					centraCheckoutScript: action.data.selection?.centraCheckoutScript,
				},
			};
		}

		case INITIATED_SCRIPT: {
			return {
				...state,
				initiatedScript: true,
			};
		}

		case 'RECEIPT_DATA': {
			let receiptSnippet = false;
			if (action.data.order.paymentMethodData && action.data.order.paymentMethodData.snippet) {
				receiptSnippet = action.data.order.paymentMethodData.snippet;
			}

			return {
				...state,
				selectionError: false,
				selectionErrorStock: false,
				selection: { // Replace all data every time.
					token: action.data.token,
					order: action.data.order.order,
					currency: action.data.order.currency,
					date: action.data.order.date,
					items: action.data.order.items.map((item) => ({
						item: item.item,
						size: item.size,
						name: item.product.name,
						id: `p${item.product.centraProduct}-v${item.product.centraVariant}`,
						sku: item.product.productSku,
						brand: item.product.brandName,
						variant: item.product.variantName,
						category: item.product.categoryUri,
						quantity: item.quantity,
						line: item.line,
						priceEach: item.priceEach,
						priceEachAsNumber: item.priceEachAsNumber,
						totalPrice: item.totalPrice,
						totalPriceAsNumber: item.totalPriceAsNumber,
						priceEachBeforeDiscount: item.priceEachBeforeDiscount,
						priceEachBeforeDiscountAsNumber: item.priceEachBeforeDiscountAsNumber,
						anyDiscount: item.anyDiscount,
						taxPercent: item.taxPercent,
						priceEachWithoutTax: item.priceEachWithoutTax,
						priceEachWithoutTaxAsNumber: item.priceEachWithoutTaxAsNumber,
						priceEachReduction: item.priceEachReduction,
						priceEachReductionAsNumber: item.priceEachReductionAsNumber,
					})),
					discounts: deepClone(action.data.order.discounts),
					totals: { ...action.data.order.totals },
					address: { ...action.data.order.address },
					shippingAddress: { ...action.data.order.shippingAddress },
					receiptSnippet,
				},
			};
		}

		case 'RECEIPT_ERROR': {
			return {
				...state,
				selectionError: action.reason,
			};
		}

		case DESTROY_SELECTION: {
			localStorage.removeItem('selection');
			localStorage.removeItem('selectionCache');
			deleteCookie('selection');
			deleteCookie('receiptShown');

			return {
				...state,
				items: {},
				selectionCache: {},
				useShippingAddress: false,
				vouchers: {
					currentValue: '',
					error: false,
				},
				payment: {
					...state.payment,
					termsAndConditions: false,
				},
				paymentReturn: {},
				addToBagError: false,
				selectionError: false,
				selectionErrorStock: false,
				selection: {
					token: '',
				},
				destroySelection: false,
			};
		}

		case ERROR_NOTIFICATION:
			return {
				...state,
				notification_sent: false,
				notification_error: true,
			};

		case SUCCESS_NOTIFICATION:
			return {
				...state,
				notification_sent: true,
				notification_error: false,
			};

		case 'CLEAR':
			return {
				...state,
				notification_sent: false,
				notification_error: false,
			};

		default:
			return state;
	}
};

export { initialState as checkoutState };
export default checkout;
